import { useContext, useState, useRef, useEffect } from "react";
import { WillEditorContext } from "../will-editor";

import STKTextField from "@/components/common/text-field";

type Props = {
    label?: string,
    name: string,
    textarea?: boolean,
    rows?: number
    validate?: string
}

const WillEditorInput = ( props:Props ) => {

    const { will, onChangeHandler, simpleValidator } = useContext(WillEditorContext);
    
    let invalid = props.validate ? simpleValidator.current.message( props.name, will?.fields[props.name], props.validate ) : null;

    return(
        <>
        <STKTextField textarea={ props.textarea } 
                      rows={props.rows} 
                      label={props.label} 
                      name={props.name} 
                      defaultValue={will?.fields[props.name]} 
                      onChange={onChangeHandler} 
                      invalid={ invalid }
        /> 
        
        </>
    );

}

export default WillEditorInput;